import React,{useEffect, useState,useContext } from 'react';
import { useTranslation } from "react-i18next";
import UserContext from '../../generic/components/appContext';
import axios from "axios";

const LeaderboardBanner = (props) => {
    let [show, setShow] = useState('hide');
    let [gameId, setGameId] = useState(props.data.id ? props.data.id : null);
    let [arrowBtn, setArrowBtn] = useState('');
    let [awards, setAwards] = useState(props.data.awards ? props.data.awards : "");
    let [leaderboardData, setLeaderboardData] = useState(props.data.leaderboard ? props.data.leaderboard : []);
    let [page, setPage] = useState(1);
    let [pageCount, setPageCount] = useState(20);
    const [finalPage, setFinalPage] = useState(1);
    const [gettingData,setGettingData] = useState(false);
    const {userId,databaseURL} = useContext(UserContext);
   
    let [playerData, setPlayerData] = useState([]); 
    const { t } = useTranslation();

    useEffect(() => {
        
        if(leaderboardData){
            getPlayerData(leaderboardData);
        }
        
    },[])

    const getLeaderboardData = async(newPage) =>{
        if(gettingData === false){
            setGettingData(true);
            setPage(newPage);
            
            return await axios

                .get(`${databaseURL}/api/lobby/leaderboard/${userId}/${gameId}?page=${newPage}&pageSize=${pageCount}`)
                .then((response) => {
                    
                    if(response && response.data){
                        let newleaderboard = [];
                        if(response.data.leaderboard){
                            newleaderboard = response.data.leaderboard;
                            
                        }
                        // if(response.data.currentPlayerPosition){
                        //     setHighlightPlayer(response.data.currentPlayerPosition);
                        // }
                        let leaderboardStart = newleaderboard.length === 0 ? 0 : newleaderboard[newleaderboard.length-1].rank
                        if(awards.length > leaderboardStart) {
                            newleaderboard.forEach(leaderboardItem => {
                                leaderboardItem.award = getAward(leaderboardItem.rank, "");
                            });
                
                            for(let i = leaderboardStart; i < awards.length; i++) {
                                newleaderboard.push({award: awards[i].award, rank: awards[i].position});
                            }
                            
                        } 

                        // newleaderboard.forEach(leaderboardItem => {
                        //     if(leaderboardItem.highlight === 1){
                        //         setHighlightPlayer('');
                                
                        //     }
                        //});
                        setLeaderboardData(newleaderboard);
                        setFinalPage(response.data.finalPage === 1 ? 1 : 0);

                    }
                    setGettingData(false);
                })
                .catch((error) => {
                    setGettingData(false);
                    alert(error)
                    console.log(error);
                })
        }
        
    }

    const moveToNextLeaderboardPage = () => {
        let newPage = page+1
        getLeaderboardData(newPage);

    }

    const backToPreviousLeaderboardPage = () => {
        let newPage = page-1;
        if(newPage > 0){
            
            getLeaderboardData(newPage);
        }
    }
    

    const getPlayerData = (data) =>{
        const filtered = data.filter(obj => {
            return obj.highlight === 1;
        });

        if(filtered){
            setPlayerData(filtered[0]);
        }
    }

    const getAward = (rank,cssCol) =>{
        let award = "";


        if(awards){
            awards.forEach((item, i)=> {
                if(rank === item.position){
                    if(item.award.indexOf("FREESPINS")>-1){
                        let awardVal = item.award.slice(0, item.award.indexOf("FREESPINS"));
                        award = <>{awardVal} <img alt="icon" className={`entain-table-sm-icons ${cssCol}`} src={require('../../assets/images/slots-race-free-spins.svg').default} /></>;
                    }else if(item.award.indexOf("BONUS")>-1){
                        let awardVal = item.award.slice(0, item.award.indexOf("BONUS"));
                        award = <>{awardVal} <img alt="icon" className={`entain-table-sm-icons ${cssCol}`} src={require('../../assets/images/slots-race-bonus.svg').default} /></>;
                    }else if(item.award.indexOf("CASH")>-1){
                        let awardVal = item.award.slice(0, item.award.indexOf("CASH"));
                        award = <>{awardVal} <img alt="icon" className={`entain-table-sm-icons ${cssCol}`} src={require('../../assets/images/slots-race-cash.svg').default} /></>;
                    }else if(item.award.indexOf("FREEBETS")>-1){
                        let awardVal = item.award.slice(0, item.award.indexOf("FREEBETS"));
                        award = <>{awardVal} <img alt="icon" className={`entain-table-sm-icons ${cssCol}`} src={require('../../assets/images/freebet_Slot_masters.svg').default} /></>;
                    }else if(item.award.indexOf("£")>-1){
                        let awardVal = item.award.slice(item.award.indexOf("£")+1, item.award.length);
                        if(isNaN(awardVal)){
                            award = item.award;
                        }else{
                            awardVal = "£" + (Math.round(awardVal) / 100).toFixed(2);
                            award = <>{awardVal}</>;
                        }
                    }else{
                        award = item.award;
                    }
                }
            });
        }
        return award;
    }
    

    const expandSection = () => {
        if(show === 'hide'){
            setShow('show');
            setArrowBtn('down');
            getLeaderboardData(1);
        }else{
            setShow('hide');
            setArrowBtn('');
        }
    }
    return( 
        <div className="card-section-expand">
                <div className={`card-banner ${props.cardState !== 'completed' ? 'white' : ''}`}  onClick={expandSection}>
                    <div className="card-row">
                        <div className="col-4">
                            <div className="card-title-sm">{t("LEADERBOARD")}</div>
                        </div>
                        <div className="col-7">
                            <div className="row card-desc">
                                <div className="col-3 ">
                                    <div className="card-desc-title">{t("RANK")}</div>
                                    <div className="">{playerData && playerData.rank}</div>
                                </div>
                                <div className="col-4">
                                    <div className="card-desc-title">{t("POINTS")}</div>
                                    <div className="">{playerData && playerData.numPoints}</div>
                                </div>
                                <div className="col-5">
                                    <div className="card-desc-title">{t("PRIZE")}</div>
                                    <div className="">{playerData && getAward(playerData.rank, "white-icon")}</div>
                                </div>
                            </div>
                        </div>
                        <div className="col-1 d-flex align-items-center justify-content-end">
                            <img className={`card-arrow ${arrowBtn}`} alt="arrowSVG" src={require('../../assets/images/arrow.svg').default}/>   
                        </div>
                    </div>
                </div>
                <div className={`container card-table ${show}`}>
                    <div className="row gx-1 mb-1">
                        <div className="col-2 table-col">
                            <div className="p-1 title">{t("RANK")}</div>
                        </div>
                        <div className="col-4 table-col">
                            <div className="p-1 title">{t("PLAYER")}</div>
                        </div>
                        <div className="col-3 table-col">
                            <div className="p-1 title">{t("POINTS")}</div>
                        </div>
                        <div className="col-3 table-col">
                            <div className="p-1 title">{t("PRIZE")}</div>
                        </div>
                    </div>
                    {page === 1 ?
                    <div className="mb-1" style={{paddingTop:"4px", paddingBottom:"4px"}}>
                        {/* <img style={{opacity: 0.1}} alt="caretdown" src={require("../../assets/sky/images/caretup.png")} />*/}
                            <img style={{opacity: 0.2}} className={`card-arrow down`} alt="caretdown" src={require('../../assets/images/arrowblack.svg').default} />
                        </div> 
                    :
                        <div className="mb-1" style={{paddingTop:"4px", paddingBottom:"4px"}} onClick={()=>backToPreviousLeaderboardPage()}>
                            {/*<img style={{opacity: 1}}  alt="caretdown" src={require("../../assets/sky/images/caretup.png")} />*/}
                            <img style={{opacity: 1}} className={`card-arrow down`} alt="caretdown" src={require('../../assets/images/arrowblack.svg').default} />
                        </div> 
                    }
                    
                    {leaderboardData && leaderboardData.map((player,index) => (
                    
                        <div key={index} className={`row gx-1 mb-1 table-row ${player.highlight === 1 ? "highlight" : "" }`}>
                            <div className="col-2 table-col">
                                <div className="p-1">{player.rank}</div>
                            </div>
                            <div className="col-4 table-col">
                                <div className="p-1">{player.name}</div>
                            </div>
                            <div className="col-3 table-col">
                                <div className="p-1">{player.numPoints}</div>
                            </div>
                            <div className="col-3 table-col">
                                <div className="p-1">{getAward(player.rank,"")}</div>
                            </div>
                        </div>
                   
                    ))}
                    <div className="mt-2 d-flex justify-content-center align-items-center">
                    {finalPage === 1 ? 
                        <div style={{width:"100%", textAlign:"center"}}>
                            <img style={{opacity: 0.2}} className={`card-arrow`}  alt="caretdown" src={require('../../assets/images/arrowblack.svg').default} />    
                        </div>
                    :
                        <div style={{width:"100%", textAlign:"center"}} onClick={()=>moveToNextLeaderboardPage()}>
                            <img style={{opacity: 1}} className={`card-arrow`} alt="caretdown" src={require('../../assets/images/arrowblack.svg').default} />    
                        </div>
                    }       
                </div>
                     
                </div>
            </div>
        );
};
    
export default LeaderboardBanner;